module.exports = __webpack_public_path__ + "img/e921943.png";